import { Container } from 'ui/container'
import { CasesList } from 'features/admin/cases'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminCasesPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Управление кейсами</span>
            </div>
            <Container>
                <CasesList />
            </Container>
        </div>
    )
}

export default AdminCasesPage
